import { axiosInstance as request } from '@api/rest.service'

const api = '/meta-data-categories'

/**
 * @description GET /meta-data-categories
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_CATEGORIES = () => request.get(api)

/**
 * @description POST /meta-data-categories
 * @returns {AxiosPromise<any>}
 */
export const CREATE_METADATA_CATEGORY = payload => request.post(api, payload)

/**
 * @description PUT /meta-data-categories/{id}/
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_METADATA_CATEGORY = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /meta-data-categories/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_CATEGORY_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /meta-data-categories/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_METADATA_CATEGORY = id => request.delete(`${api}/${id}`)
